module.exports = __webpack_public_path__ + "img/case-type-arrow.215d93c8.svg";